<template>
  <div class="container">
    <form class="needs-validation" id="form" @keydown.enter.prevent="nextInput" novalidate>
      <form-locale />
      <company-input />
      <employee-input />
      <employment-details-input />
      <pension-input />
      <health-control-input />
      <job-categories-input />
      <salary-input />
      <working-conditions-input />
      <salary-period-input />
      <driving-license-input />
      <tachograph-license-input />
      <qualifications-input />
      <sickness-input />
      <holiday-input />
      <social-security-institutions-input />
      <special-terms-input />
    </form>
  </div>
</template>

<script>
import CompanyInput from "@/shared/components/form/CompanyInput";
import DrivingLicenseInput from "@/shared/components/form/DrivingLicenseInput";
import EmployeeInput from "@/shared/components/form/EmployeeInput";
import EmploymentDetailsInput from "./EmploymentDetailsInput";
import FormLocale from "./FormLocale";
import HealthControlInput from "@/shared/components/form/HealthControlInput";
import HolidayInput from "@/shared/components/form/HolidayInput";
import JobCategoriesInput from "@/shared/components/form/JobCategoriesInput";
import PensionInput from "@/shared/components/form/PensionInput";
import QualificationsInput from "@/shared/components/form/QualificationsInput";
import SalaryInput from "@/shared/components/form/SalaryInput";
import SalaryPeriodInput from "@/shared/components/form/SalaryPeriodInput";
import SicknessInput from "./SicknessInput";
import SocialSecurityInstitutionsInput from "@/shared/components/form/SocialSecurityInstitutionsInput";
import SpecialTermsInput from "@/shared/components/form/SpecialTermsInput";
import TachographLicenseInput from "@/shared/components/form/TachographLicenseInput";
import WorkingConditionsInput from "./WorkingConditionsInput";

export default {
  components: {
    CompanyInput,
    DrivingLicenseInput,
    EmployeeInput,
    EmploymentDetailsInput,
    FormLocale,
    HealthControlInput,
    HolidayInput,
    JobCategoriesInput,
    PensionInput,
    QualificationsInput,
    SalaryInput,
    SalaryPeriodInput,
    SicknessInput,
    SocialSecurityInstitutionsInput,
    SpecialTermsInput,
    TachographLicenseInput,
    WorkingConditionsInput
  },
  methods: {
    nextInput(event) {
      // eslint-disable-next-line
      let inputs = $("input, select, textarea");
      let index = inputs.index(event.target) + 1;
      inputs.eq(index).focus();
    }
  }
};
</script>

<style>
fieldset {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid black;
}

legend {
  margin-bottom: 0;
  font-size: 1.3rem;
}

/* Overwrite bootstraps form-control styling. Needed because we use the form-control class to trigger error messages. */

.form-control {
  box-sizing: border-box;
  -webkit-appearance: none;
  width: 100%;
  background: #fff;
  border: 2px solid #2a18cc;
  border-radius: 0;
  font-size: 1.05rem;
  line-height: 1.5rem;
  color: #313841;
}

.form-control.datepicker {
  background-color: #fff;
}

.form-control textarea {
  width: 100%;
}

.form-group.no-label {
  margin-top: 2rem;
}

.input-group-text {
  color: #fff;
  font-weight: 500;
  background-color: #2a18cc;
  border: 2px solid #2a18cc;
}

.input-group-text.clickable-addon:hover {
  background-color: #1cd6ac;
  border: 2px solid #1cd6ac;
  cursor: pointer;
}

input[type="checkbox"]:focus,
input[type="radio"]:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

input[type="checkbox"]:disabled,
label.disabled {
  opacity: 0.5;
}

#select_agreement option:last-child {
  font-weight: 500;
}

.fa.fa-angle-down,
.fa.fa-angle-up {
  position: relative;
  top: 3px;
  font-size: 1.5rem;
  margin-right: 1rem;
}

a[aria-expanded="true"] .fa.fa-angle-down {
  display: none;
}

a[aria-expanded="false"] .fa.fa-angle-up {
  display: none;
}

.fa.fa-plus-square {
  font-size: 1rem;
  margin-left: 0.5rem;
}

.fa.fa-question-circle {
  margin-left: 0.5rem;
}

a.fa.fa-question-circle,
a.fa.fa-plus-square {
  color: #2a18cc;
}

a.fa.fa-question-circle:hover,
a.fa.fa-plus-square:hover {
  color: #1cd6ac;
  cursor: pointer;
}

a.fa.icon-inline {
  color: #2a18cc;
  position: relative;
  top: 15px;
}

.inline > div {
  display: inline-block;
  width: 45%;
}

/* Remove green borders from valid input fields when validating */

.custom-select.is-valid,
.form-control.is-valid,
.was-validated .custom-select:valid,
.was-validated .form-control:valid {
  border-color: #2a18cc;
}

/* Remove green text from check marks */

.form-check-input.is-valid ~ .form-check-label,
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #313841;
}

/* Invalid input field styling from DE website */

.custom-select.is-invalid,
.form-control.is-invalid,
.was-validated .custom-select:invalid,
.was-validated .form-control:invalid {
  background-color: #ffedeb;
  border-color: #ff4935;
}

.invalid-feedback {
  margin-top: 0;
}

/* Error message styling from DE website */

.invalid-feedback span {
  position: absolute;
  bottom: -25px;
  right: 0px;
  text-align: right;
  color: #ff4935;
  font-size: 14.5px;
  font-weight: 500;
  margin-top: 0;
  min-height: 17px;
}

.label-notice {
  margin-left: 5px;
  font-size: 0.8rem;
  font-style: italic;
}

.translation-links > ul {
  margin: 0 0 1rem 0;
}

.clickable-text:hover,
.clickable-text:hover > a.fa.fa-plus-square {
  color: #1cd6ac;
  cursor: pointer;
}
</style>
